import { Component, EventEmitter, Input, OnDestroy, Output, SimpleChanges } from '@angular/core';
import { Product, ProductListManualVm } from '../../../models/project-vm';
import { ProjectService } from '../../../services/project.service';
import { StorageService } from '../../../../Common/services/storage.service';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { FormControl } from '@angular/forms';
import { empty, Observable, Subscription } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { RefTypeEnum } from '../../../enums/ref-type-enum';
import { ExcelExportService } from '../../../services/excel-export.service';
import { ExcelExportConfig } from '../excel-export-config';
import * as ExcelJS from 'exceljs';
import { ProjectConstants } from '../../../constants/component-messages';
import { DataShareService } from '../../../services/data-share.service';
import { ConfirmationService } from 'primeng/api';
import { MessageService } from '../../../services/message.service';
import { UserRoleServiceService } from '../../../../shared/services/user-role-service.service';
import { ErrorLoggerService } from '../../../../shared/services/error-logger.service';
import { MasterService } from '../../../../administration/services/master.service';
import { UnsavedChangesService } from '../../../../unsaved-changes.service';

interface AutoCompleteCompleteEvent {
  originalEvent: Event;
  query: string;
}

@Component({
  selector: 'app-common-product-list-manual',
  templateUrl: './common-product-list-manual.component.html',
  styleUrl: './common-product-list-manual.component.css'
})
export class CommonProductListManualComponent implements OnDestroy{
  @Input() selectedProductRows?: ProductListManualVm[] | null;
  @Input() categoryId?: string; // Receive vendorId from parent component 
  @Input() reciveCoomunication: any = {};  
  @Input() componentUsedBy: RefTypeEnum = RefTypeEnum.None;
  @Input() disableAfterReview: boolean = false;
  @Input() selectedCategories: number[]=[];
  @Input() categoryList: any[] | undefined = [];
  
  @Input() isProductListManualChecked: boolean = false;

  @Input()  productItems: any[]=[];
  @Input() orgProductsList: any[]=[];
  isRadioChecked: boolean = false;
  enableAddProduct:boolean = true;


  @Output() notifyParent: EventEmitter<{}> = new EventEmitter<{}>();
  @Output() notifyRButtonStatus: EventEmitter<{}> = new EventEmitter<{}>();
  @Output() notifyProductSelections: EventEmitter<{}> = new EventEmitter<{}>();
  @Output() updatedProductRows: EventEmitter<ProductListManualVm[]> = new EventEmitter<ProductListManualVm[]>();
  @Output() onChangeAddProductCategoryID: EventEmitter<number | null | undefined> = new EventEmitter<number | null | undefined>();

  downloadLink: string = 'Products.xlsx';

  disableProductsSection: boolean = false;
  parentCol = "text-center align-middle tdHeaderBg";
  parentColAutoComplete = "tdHeaderBg position-relative";
  childCol = "text-center align-middle";
  childColAutoComplete = "align-middle";
  subscription1: Subscription = new Subscription();
  subscription2: Subscription = new Subscription();
  isParentSelected: boolean = true;

  //productItems: any[] = [];
  cusromProductItems: any[] = [];
  cusromFilterProductItems: any[] = [];
  categoryProductItems:any[]=[];
  //selectedProducts: any[] | undefined;

  filteredProducts: any[] = []; 
  filteredProductsForCustom: any[] = [];

  refinecategoryList: any[] | undefined = [];
  newProductCategoryID: number | null = null;
  showNewProductCategory:boolean=false;
  isShowRemoveProductIcon: boolean=false;
  allProducts:Product[]=[];
  emptyMessage: string='';
  constructor(private projectService: ProjectService,
    private storageService: StorageService,
    private msgService: MessageService,
    private userRoleService: UserRoleServiceService,
    private errorLogService: ErrorLoggerService,
    private ngxService: NgxUiLoaderService,
    private excelExportService: ExcelExportService,
    private dataShareService:DataShareService,
    private confirmationService:ConfirmationService,
    private masterService:MasterService,
    private unsavedChangesService: UnsavedChangesService
  ) {
  }
  onAnyFieldValueChange(e:boolean){
    if(e){
      this.unsavedChangesService.setUnsavedChanges(true);
    }
  }

  ngOnInit()
  {
   // this.newProductCategoryID=null;
    this.selectedCategories;
    this.categoryList;
    this.refineCategoryList(this.selectedCategories);
    //   ///this is to capture the products upload selection type change.
    //   this.dataShareService.dataShareOfProductsSelection.subscribe(result=>{
    //     if(result != null && result.isFrom=="list"){
    //       if(result.isDataToRemove==false){
    //         this.isProductListManualChecked=true;
    //         this.disableProductsSection = false;
    //       }else{
    //         this.isProductListManualChecked=false;
    //         this.disableProductsSection = true;

    //         // this is to notify parent so that it can update the object
    //         this.notifyProductSelections.emit(
    //           {from: 'list', rejected: true});
    //       }
    //     }
    // });

    //this.loadDefaultSelection(true);

    if(!this.selectedProductRows || this.selectedProductRows?.length==0){
      //this.selectedProductRows![index].isParentSelected
      this.selectedProductRows = [];
      let emptyData=new ProductListManualVm();
      emptyData.product=null;
      emptyData.vendorItemNumber='';
      emptyData.upc='';
      emptyData.refID=0;
      emptyData.productID=0;
      emptyData.type=this.componentUsedBy;
      //emptyData.subProducts=[];
      emptyData.isManuallyAddedNewProduct=false;
      emptyData.isParentSelected=true;
      emptyData.isItRemove=false;
      this.selectedProductRows?.push(emptyData);
    }
   
  

    this.subscription1 = this.dataShareService.switchBetweenProducts.subscribe(result => {
     
      // Check if there is a result and if the switch is coming from the "list" mode
      if (result != null && result.isFrom === "listradio") {
        this.isRadioChecked = !result.checked;
      }
    });

    this.subscription2 = this.dataShareService.switchBetweenProducts.subscribe(result => {
    
      this.showNewProductCategory=false;
      this.newProductCategoryID=null;
      // Check if there is a result and if the switch is coming from the "list" mode
      if (result != null && result.isFrom === "list") {
        
        // If the action is to display the confirmation dialog
        if (result.action === 'displayDialog') 
        {
          
          // Check if any products are selected (i.e., selectedProductRows is not null, undefined, or empty)
          if (this.selectedProductRows != null &&
              this.selectedProductRows !== undefined &&
              this.selectedProductRows.length > 0) 
          {
    
            // Check if there is any product with a count greater than 0
            const hasProductWithCount = this.selectedProductRows.some(p => p.productID! > 0);

            this.selectedProductRows.sort((a, b) => {
              if (a.installationProductID && b.installationProductID) {
                return a.installationProductID - b.installationProductID;
              } else if (a.installationProductID) {
                return -1; // If only 'a' has an installationProductID
              } else if (b.installationProductID) {
                return 1; // If only 'b' has an installationProductID
              } else {
                return 0; // If both are undefined
              }
            });

            if(hasProductWithCount)
            {
              // Show confirmation dialog to the user
              this.confirmationService.confirm({
                header: "Products Dialog",
                icon: 'pi pi-exclamation-triangle',
                message: "You are about to change the mode of adding Products. " +
                        "If you have added any products, those will be deleted.",
                
                // If the user confirms, proceed with the switch
                accept: () => {
                  //this.isProductListManualChecked=false;
                  this.disableProductsSection = true;

                  this.dataShareService.emitDataBetweenProducts({
                    "action":'accepted',"isFrom":"manual"
                  });

                  // this is to notify parent so that it can update the object
                  this.notifyProductSelections.emit(
                    {from: 'list', rejected: true});
                },
                
                // If the user rejects, keep the current mode and prevent data removal
                reject: () => {

                  this.isRadioChecked=true;
                  this.dataShareService.emitDataProductRadioChecked({
                    checked: this.isRadioChecked,
                    isFrom: 'manualradio'
                  });

                  //this.isProductListManualChecked=true;
                  this.disableProductsSection = false;
                  this.dataShareService.emitDataBetweenProducts({
                    "action":'rejected',"isFrom":"manual"
                  });
                }
              });
            }
            else
            {
              //this.isProductListManualChecked=false;
              this.disableProductsSection = true;
    
              this.dataShareService.emitDataBetweenProducts({
                "action":'accepted',"isFrom":"manual"
              });
            }            
          }
        }

        // If the action is to display the confirmation dialog
        if (result.action === 'rejected') {          
          //this.isProductListManualChecked=false;
          this.disableProductsSection = true;
        }
        if (result.action === 'accepted') {          
          //this.isProductListManualChecked=true;
          this.disableProductsSection = false;
        }
      }
    });
  }
  toggleSelection(type: string,index:number) {
    //this.isParentSelected = type === 'parent';
    if(!this.disableProductsSection) {
        if(!this.disableAfterReview){
          this.selectedProductRows![index].isParentSelected = !this.selectedProductRows![index].isParentSelected;
          this.assignTransactionParentId();
         
          this.updatedProductRows.emit(this.selectedProductRows!);
        }
      }
    
  }
  assignTransactionParentId(){
    let lastParentSelectedId: number | undefined = undefined;
    this.selectedProductRows!.forEach(row => {
      if (row.isParentSelected) {
        // Update lastParentSelectedId when we find a row where isParentSelected is true
        lastParentSelectedId = row.productID;
      } else {
        // For rows where isParentSelected is false, assign the last parent selected ID
        row.transactionParentId = lastParentSelectedId;
      }
    });
  }
  
  
  ngOnDestroy() {
    // Unsubscribe from all subscriptions
    this.subscription1.unsubscribe();
    this.subscription2.unsubscribe();
  }

  loadDefaultSelection(isChecked: boolean)
  {
    // this.isRadioChecked=isChecked;
    // this.dataShareService.emitDataProductRadioChecked({
    //   checked: this.isRadioChecked,
    //   isFrom: 'listradio'
    // });

    // this.dataShareService.emitDataBetweenProducts({
    //   "action":'displayDialog',"isFrom":"list"
    // });

    this.isRadioChecked=true;
      this.dataShareService.emitDataProductRadioChecked({
        checked: this.isRadioChecked,
        isFrom: 'manualradio'
      });

      this.dataShareService.emitDataBetweenProducts({
        "action":'displayDialog',"isFrom":"manual"
      });
  }

  ngAfterViewInit(): void {
    
  }

  ngOnChanges(changes: SimpleChanges) {
    // if (changes['categoryId'] && this.categoryId !== null) {
    //   if(parseInt(this.categoryId!) > 0)
    //   {
    //     let catgId = Number(this.categoryId);
    //     this.projectService.getAllProductsByCategory(catgId).subscribe(data =>{
    //       this.productItems = [];
    //       this.productItems = data;
    //     })
    //   }
    // }
    // if(this.selectedCategories.length>0){
    //   this.masterService.getProductsByCategories(this.selectedCategories).subscribe(res=>{
    //     if(res){
    //         this.productItems = [];
    //         this.productItems = res;
    //         this.cusromProductItems=res;
    //         this.productItems=this.productItems.filter(x=>x.isVerified);
    //     }
    //   });

    //   this.refineCategoryList(this.selectedCategories);
    // }

     if (changes['productItems'] && this.productItems !== null) {
      this.cusromProductItems=[];
      this.productItems=this.productItems.filter(x=>x.isVerified);
      this.cusromProductItems=this.productItems;
       this.refineCategoryList(this.selectedCategories);

      
    }

    if (changes['orgProductsList'] && this.orgProductsList !== null) {
      this.allProducts=[];
      this.allProducts=this.orgProductsList.filter(x=>x.isVerified);
      this.getselectedCategoryProducts(this.selectedCategories);
      
    }

    
    if(this.selectedProductRows != null)
    {
      const selectedNewProductRows = this.selectedProductRows?.filter(
        x => x.isManuallyAddedNewProduct == null || x.isManuallyAddedNewProduct == false
    ) ?? [];
      //this.selectedProductRows = [];
      if(selectedNewProductRows.length==0){
      this.addEmptyProductItem();
      }
    }else{
      if(this.selectedProductRows==null){
      this.addDefaultEmptyProductItem();
      }
    }
    this.checkIsAddEmptyRow();



    // if (changes['isProductListManualChecked'] && this.isProductListManualChecked !== null) {
       
    //   if(this.isProductListManualChecked)
    //     {
    //       this.notifyParent.emit({
    //         from: "productlistmanual",
    //         action: "manualproductsseelction"
    //       });

    //       this.disableProductsSection = false;
    //       this.isProductListManualChecked = true;
    //     }
    //     else
    //     {
    //       this.disableProductsSection = true;
    //       this.isProductListManualChecked = false;
    //     }
    // }

    // if (changes['reciveCoomunication'] && this.reciveCoomunication !== null) {
    //   //console.log('reciveCoomunication', this.reciveCoomunication);
      
    //   if(this.reciveCoomunication.from == "productlist")
    //     {
    //       if(this.reciveCoomunication.action == "uploadproductswithexcel")
    //       {
    //         this.disableProductsSection = true;
    //       }
    //     }
    // }
    

  }


  filterProducts(event: AutoCompleteCompleteEvent) {
    const query = event.query.toLowerCase();
    let filtered: any[] = [];

    // Use a map to track unique products by their ID (or another unique identifier)
    let productMap = new Map<number, any>(); // Assuming productID is a number, replace if needed

    if (!this.selectedCategories || this.selectedCategories.length === 0) {
        this.msgService.htmlError(ProjectConstants.PRODUCT_KEY_SEARCH_PRODUCTS);
        return;
    }

    // Normalize the UPC by removing leading zeros
    const normalizeUPC = (upc: string) => upc.replace(/^0+/, '');

    // Normalize the query for UPC search
    const normalizedQuery = normalizeUPC(query);

    // First pass: Exact UPC matches
    for (let product of this.productItems as any[]) {
        const normalizedProductUPC = normalizeUPC(product.upc);
        
        //const upcMatch = normalizedProductUPC === normalizedQuery;
        const upcMatch = normalizedProductUPC.includes(normalizedQuery);

        // If it's an exact UPC match, add it (if not already added)
        if (upcMatch && !productMap.has(product.productID)) {
            productMap.set(product.productID, product);
        }
    }

    // Second pass: Partial matches (productTitle or vendorItemNumber)
    for (let product of this.productItems as any[]) {
        const productTitleMatch = product.productTitle.toLowerCase().includes(query);
        const vendorItemNumberMatch = product.vendorItemNumber.toLowerCase().includes(query);

        // Add partial matches only if the product wasn't added in the exact match phase
        if ((productTitleMatch || vendorItemNumberMatch) && !productMap.has(product.productID)) {
            productMap.set(product.productID, product);
        }
    }

    // Convert map values back to an array
    filtered = Array.from(productMap.values());

    // Remove products where the same ProductTitle and UPC exist more than once
    const uniqueProducts = new Map<string, any>(); // To store unique productTitle-UPC combinations

    filtered = filtered.filter(product => {
        const key = product.productTitle.toLowerCase() + '-' + normalizeUPC(product.upc);
        if (!uniqueProducts.has(key)) {
            uniqueProducts.set(key, product);
            return true; // Keep the product
        } else {
            return false; // Remove duplicate
        }
    });
  if(filtered.filter(product => product.upc === query).length>0){
    filtered=filtered.filter(x=>x.upc==query) ;
  }
    // If the filtered array contains more than one product, remove the last one
    // if (filtered.length > 1) {
    //     filtered.pop(); // Removes the last product
    // }

    this.filteredProducts = filtered;
}


filterProductsForCustomItems(event: AutoCompleteCompleteEvent) {
  //this.filteredProductsForCustom = [];
  const query = event.query.toLowerCase();
  let filtered: any[] = [];

  // Check if newProductCategoryID is missing
  if (!this.newProductCategoryID) {
    //this.msgService.htmlError(ProjectConstants.CUSTOM_PRODUCT_KEY_SEARCH_PRODUCTS);
    //return;  // Exit early if newProductCategoryID is missing, so further processing doesn't happen
  }else{
    this.changeCategory();
  }
  this.filteredProductsForCustom = [];
  // Use a map to track unique products by their ID
  let productMap = new Map<number, any>();

  // Normalize the UPC by removing leading zeros
  const normalizeUPC = (upc: string) => upc.replace(/^0+/, '');

  const normalizedQuery = normalizeUPC(query);

  // First pass: Exact UPC matches
  for (let product of this.cusromFilterProductItems as any[]) {
    const normalizedProductUPC = normalizeUPC(product.upc);
    if (normalizedProductUPC === normalizedQuery && !productMap.has(product.productID)) {
      productMap.set(product.productID, product);
    }
  }

  // Second pass: Partial matches (productTitle or vendorItemNumber)
  for (let product of this.cusromFilterProductItems as any[]) {
    const productTitleMatch = product.productTitle.toLowerCase().includes(query);
    const vendorItemNumberMatch = product.vendorItemNumber.toLowerCase().includes(query);
    if ((productTitleMatch || vendorItemNumberMatch) && !productMap.has(product.productID)) {
      productMap.set(product.productID, product);
    }
  }

  // Convert map values back to an array and remove duplicates
  filtered = Array.from(productMap.values());

  const uniqueProducts = new Map<string, any>();
  filtered = filtered.filter(product => {
    const key = product.productTitle.toLowerCase() + '-' + normalizeUPC(product.upc);
    if (!uniqueProducts.has(key)) {
      uniqueProducts.set(key, product);
      return true;
    } else {
      return false;
    }
  });

  if (filtered.filter(product => product.upc === query).length > 0) {
    filtered = filtered.filter(x => x.upc == query);
  }

  // Update the filtered results
  this.filteredProductsForCustom = filtered;
}
getChildsForSelectedParent(parentId:number){
   this.projectService.getChildByParent(parentId).subscribe(data=>{
     let childRowList:ProductListManualVm[]=[];
     if(data){
      data.forEach((item: { categoryID: number | undefined; productID: number | undefined; vendorItemNumber: string | undefined; upc: string | undefined;
        productTitle: string | undefined;
       })=>{
         let childrow:ProductListManualVm={};
         childrow.categoryID= item.categoryID;
         childrow.productID= item.productID;
         childrow.vendorItemNumber = item.vendorItemNumber;
         childrow.upc = item.upc;
         childrow.isParentSelected = false;
        childrow.refID = 0;
        childrow.type = this.componentUsedBy;
        childrow.newProductID = 0;
        childrow.parentID=parentId;
        childrow.newProductID=item.productID;
        childrow.newProductParentID=parentId;
        childrow.newProductTitle= item.productTitle;
        childrow.transactionParentId=parentId;
        childrow.isItRemove=false;
        childrow.isManuallyAddedNewProduct=true;
         childRowList.push(childrow);
      })
     }     

      // Now add the child rows after the selected parent
      const existingChildRows = this.selectedProductRows!.filter(row => row.newProductParentID === parentId);
    if (childRowList && childRowList.length > 0 && existingChildRows && existingChildRows.length==0) {
      // Find the index of the selected parent in the `selectedProductRows`
      const parentIndex = this.selectedProductRows!.findIndex(row => row.productID === parentId && row.isParentSelected);

      // If parent exists, insert the children after the parent
      if (parentIndex !== -1) {
        // Insert each child after the parent
        this.selectedProductRows!.splice(parentIndex + 1, 0, ...childRowList);
        
        // Optionally, you can emit the updated product rows if needed:
        this.updatedProductRows.emit(this.selectedProductRows!);
      }
    }
     
   });
}
// Method to remove the previous parent and its children
removePreviousParentAndChildren(previousParentID: number): void {
  // Remove the parent row and all its children
  const parentIndex = this.selectedProductRows!.findIndex(row => row.productID === previousParentID && row.isParentSelected);
  
  if (parentIndex !== -1) {
    // First, find the child rows
    let startIndex = parentIndex + 1;
    let endIndex = startIndex;
    
    // Find all child rows
    while (endIndex < this.selectedProductRows!.length && !this.selectedProductRows![endIndex].isParentSelected) {
      endIndex++;
    }

    // Remove the parent row and its children
   // this.selectedProductRows!.splice(parentIndex, endIndex - parentIndex);
   this.selectedProductRows!.splice(startIndex, endIndex - startIndex);
  }
}

  onSelect(event: any, row: any): void {
   
    let alreadyItemSelected = this.selectedProductRows!
        .filter(item => item.productID == event.value.productID);

    if (alreadyItemSelected && alreadyItemSelected.length > 0) {
        this.msgService.htmlError(ProjectConstants.PRODUCT_KEY_SELECTED_PRODUCT);
        row.product = null;  
        row.vendorItemNumber = '';
        row.upc = '';
        row.productID = 0;
        row.type = this.componentUsedBy;
        //row.subProducts = [];      
    } else {
        // Assign productTitle instead of the whole object
        row.product = event.value.productTitle;
        row.vendorItemNumber = event.value.vendorItemNumber;
        row.upc = event.value.upc;
        row.isParent = row.isParentSelected;
        row.refId = 0;
        row.productID = event.value.productID;
        row.type = this.componentUsedBy;
        row.newProductID = 0;
        if(row.isParentSelected){
        if (this.previousParentID !== null && this.previousParentID== event.value.productID) {
          this.removePreviousParentAndChildren(this.previousParentID);
        }
        this.previousParentID = event.value.productID;
        
        this.getChildsForSelectedParent(event.value.productID);
      }
        
        let results = this.productItems.filter(item => item.parentID == event.value.productID);
        if(results && results.length > 0 && row.isParentSelected== false){
          
        }
  
        // if (results && results.length > 0) {
        //     results.forEach(item => {
        //         row.subProducts.push({
        //             product: item.productTitle,
        //             vendorItemNumber: item.vendorItemNumber,
        //             upc: item.upc,
        //             isParent: false,
        //             refId: 0,
        //             type: this.componentUsedBy,
        //             productID: item.productID,
        //             subProducts: []
        //         });        
        //     });
        // } else {
        //     row.subProducts = [];
        // }
        let lastParentSelectedId: number | undefined = undefined;

// Loop through the rows to process
this.assignTransactionParentId();
        this.updatedProductRows.emit(this.selectedProductRows!);
        this.errorLogService.logMessage(this.selectedProductRows, 'Selected item:');
    }
}


  addProductItem(index: number) {
    if(!this.disableProductsSection)
    {
      if(!this.disableAfterReview)
      {
        // this.selectedProductRows!.push({
        //   product: null,
        //   vendorItemNumber:'',
        //   upc:'',
        //   refID: 0,
        //   productID: 0,
        //   type: this.componentUsedBy,
        //   isManuallyAddedNewProduct:false,
        //   isParentSelected:true,
        //   isItRemove:false,
        //   subProducts:[]});
        const newProductRow = { 
          // Add your product row properties here, e.g.:
             product: null,
          vendorItemNumber:'',
          upc:'',
          refID: 0,
          productID: 0,
          type: this.componentUsedBy,
          isManuallyAddedNewProduct:false,
          isParentSelected:true,
          isItRemove:false,
          // subProducts:[]
        };
     

      // Check if the row at the given index is a parent or child
      const targetRow = this.selectedProductRows![index];

      if (targetRow.isParentSelected) {
        // Case 1: If the selected row is a parent, find its last child and add after it
        let lastChildIndex = -1;
        
        // Find the last child for this parent
        for (let i = index + 1; i < this.selectedProductRows!.length; i++) {
          if (this.selectedProductRows![i].isParentSelected) {
            break; // Stop when we find another parent
          }
          lastChildIndex = i; // Update to the current child row
        }

        // If there are children, insert the new row after the last child
        if (lastChildIndex !== -1) {
          this.selectedProductRows!.splice(lastChildIndex + 1, 0, newProductRow);
        } else {
          // If there are no children (i.e., after the parent), insert after the parent itself
          this.selectedProductRows!.splice(index + 1, 0, newProductRow);
        }

      } else {
        // Case 2: If the selected row is a child, we add a new parent after the last parent
        let nextParentIndex = -1;

        // Loop to find the next parent after the selected child
        for (let i = index + 1; i < this.selectedProductRows!.length; i++) {
            if (this.selectedProductRows![i].isParentSelected) {
                nextParentIndex = i;
                break; // Stop when we find the next parent
            }
        }

        // If there is a parent after the child, insert the new row before that parent
        if (nextParentIndex !== -1) {
            this.selectedProductRows!.splice(nextParentIndex, 0, newProductRow);
        } else {
            // If no parent exists, insert the new row after the child
            this.selectedProductRows!.splice(index + 1, 0, newProductRow);
        }
      }

     
      }      
      const selectedNewProductRows = this.selectedProductRows?.filter(
        x => x.isManuallyAddedNewProduct == null || x.isManuallyAddedNewProduct == false
    ) ?? [];
        this.isShowRemoveProductIcon = selectedNewProductRows?.length > 1;        
    }
  }

  // removeItem(index: number) {
  //   if(!this.disableProductsSection
  //     && this.productRows.length != 1)
  //   {
  //     this.productRows.splice(index, 1);
  //   }
  // }

  handleRadioChange(event: any) {
    var target = event.target;
    if(target.checked)
    {
      //this.errorLogService.logError(this.selectedProductRows, 'handleRadioChange');
      this.isRadioChecked=true;
      this.dataShareService.emitDataProductRadioChecked({
        checked: this.isRadioChecked,
        isFrom: 'manualradio'
      });

      this.dataShareService.emitDataBetweenProducts({
        "action":'displayDialog',"isFrom":"manual"
      });

      // this.confirmationService.confirm({
      //   header: "Products Dialog",
      //   icon: 'pi pi-exclamation-triangle',
      //   message: "You are about to change the mode of adding Products. If you have added any products, those will be deleted",
      //   accept: () => {
      //     this.confirmYes();
      //   },
      //   reject: () => {
      //     target.checked=false;
      //     this.dataShareService.emitDataShareOfProductsSelection({"isDataToRemove":false,"isFrom":"manual"});
      //   }
      // });
    }
    else
    {
      alert('m');
    }
    
  }

  onProductChange(event: any) 
  {
    //this.selectedGenInfoProject.sreSpoc = event.target.value;
  }


  // masters: { productTitle: string, itemNo: string, upc: string, children: { productTitle: string, itemNo: string, upc: string }[] }[] = [
  //   { productTitle: '', itemNo: '', upc: '', children: [{ productTitle: '', itemNo: '', upc: '' }] }
  // ];

  // addMaster(index: number): void {
  //   const newMaster = { productTitle: '', itemNo: '', upc: '', children: [{ productTitle: '', itemNo: '', upc: '' }] };
  //   this.masters.splice(index + 1, 0, newMaster);
  // }

  removeMaster(index: number): void {
    if(!this.disableProductsSection)
    {
      if(!this.disableAfterReview)
      {
        if (this.selectedProductRows!.length > 1) {
          
          const removedRow = this.selectedProductRows![index];

        // Remove the row at the specified index, regardless of whether it's a parent or child
        this.selectedProductRows!.splice(index, 1);

        // If the removed row was a parent, remove all associated child rows
        if(removedRow?.productID!>0){
        if (removedRow.isParentSelected) {
          this.selectedProductRows = this.selectedProductRows!.filter(row => 
            row.transactionParentId !== removedRow.productID || row.isParentSelected // Keep rows where the parent ID doesn't match, or the row is a parent
          );
        }
      }
          
          this.showNewProductCategory=(this.selectedProductRows ?? []).some(product => (product.isManuallyAddedNewProduct && product.productID === 0 && product.isItRemove==false) ?? false);
          
          this.updatedProductRows.emit(this.selectedProductRows!);
          if(this.selectedProductRows?.length==0){
            const newProductRow = { 
              // Add your product row properties here, e.g.:
                 product: null,
              vendorItemNumber:'',
              upc:'',
              refID: 0,
              productID: 0,
              type: this.componentUsedBy,
              isManuallyAddedNewProduct:false,
              isParentSelected:true,
              isItRemove:false,
              // subProducts:[]
            };
            this.selectedProductRows.push(newProductRow);
          } 
        }
      }
     // this.checkIsAddEmptyRow();
     const selectedNewProductRows = this.selectedProductRows?.filter(
      x => x.isManuallyAddedNewProduct == null || x.isManuallyAddedNewProduct == false
  ) ?? [];
      this.isShowRemoveProductIcon = selectedNewProductRows?.length > 1;
    }
  }

  removeCustomProduct(row:ProductListManualVm,index: number): void {
    row.isItRemove=true;
    if(!this.disableProductsSection)
    {
      if(!this.disableAfterReview)
      {
        if (this.selectedProductRows!.length > 1) {
         // let objselectedProductRows=this.selectedProductRows;
         // this.selectedProductRows!.splice(index, 1);
         const removedRow = this.selectedProductRows![index];

        // Remove the row at the specified index, regardless of whether it's a parent or child
        this.selectedProductRows!.splice(index, 1);

        // If the removed row was a parent, remove all associated child rows 
        if(removedRow?.productID!>0){
          if (removedRow.isParentSelected) {
            this.selectedProductRows = this.selectedProductRows!.filter(row => 
              row.transactionParentId !== removedRow.productID || row.isParentSelected // Keep rows where the parent ID doesn't match, or the row is a parent
            );
          }
        }
    
          this.showNewProductCategory=(this.selectedProductRows ?? []).some(product => (product.isManuallyAddedNewProduct && product.productID === 0 && product.isItRemove==false) ?? false); 
          this.updatedProductRows.emit(this.selectedProductRows!);
        }
      }
     // this.checkIsAddEmptyRow();
     const selectedNewProductRows = this.selectedProductRows?.filter(
      x => x.isManuallyAddedNewProduct == null || x.isManuallyAddedNewProduct == false
  ) ?? [];
      this.isShowRemoveProductIcon = selectedNewProductRows?.length > 1;
    }
  }

  removeChild(masterIndex: number, childIndex: number): void {
    if(!this.disableProductsSection)
    {
      if(!this.disableAfterReview)
      {
        this.selectedProductRows![masterIndex].subProducts!.splice(childIndex, 1);       
        this.updatedProductRows.emit(this.selectedProductRows!);
      }
    }
  }

  // Function to flatten the nested selectedProductRows
  flattenSelectedProductRows(rows: ProductListManualVm[]): ProductListManualVm[] {
    const result: ProductListManualVm[] = [];

    // Recursive function to handle each row and its subProducts
    const flatten = (rows: ProductListManualVm[]) => {
      rows.forEach(row => {
        // Add the current row to the result
        result.push(row);

        // Recursively process subProducts
        if (row.subProducts) {
          flatten(row.subProducts);
        }
      });
    };

    flatten(rows);
    return result;
  }

  addNewProduct() {
    if (!this.disableProductsSection) {
        // Ensure selectedProductRows is initialized
        this.selectedProductRows = this.selectedProductRows || [];

        // Get the highest newProductID
          const highestNewProductID = Math.max(
            ...this.selectedProductRows.map(product => product.newProductID || 0)
          );

        this.selectedProductRows.push({
            productName: '', // Text box input for new product name
            vendorItemNumber: '',
            upc: '',
            categoryID:parseInt(this.categoryId!),
            isManuallyAddedNewProduct: true, // Indicates this is a new product row
            newProductID:highestNewProductID+1,
            type: this.componentUsedBy,
            productID:0,
            isItRemove:false,
            isParentSelected:true
        });
        this.updatedProductRows.emit(this.selectedProductRows!);
    }
    if(this.selectedCategories.length==1){
      this.newProductCategoryID=this.selectedCategories[0];
    }

    this.showNewProductCategory=(this.selectedProductRows ?? []).some(product => (product.isManuallyAddedNewProduct && product.productID === 0 && product.isItRemove==false) ?? false);
}

  exportProductsExcelData(): void {

    let dataToExport = this.flattenSelectedProductRows(this.selectedProductRows!);


    const columns = [
      { key: 'productID', header: 'ProductID', width: 17 },
      { key: 'product', header: 'ProductTitle', width: 40 },
      { key: 'upc', header: 'UPC', width: 20 },
      { key: 'vendorItemNumber', header: 'VendorItemNumber', width: 20 }
    ];

    const styles: {
      header: Partial<ExcelJS.Style>;
      default: Partial<ExcelJS.Style>;
    } = {
      header: { 
        font: { bold: true, size: 9 },
        alignment: { horizontal: 'center' as 'center' },
        fill: { // Background color for the header
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'ADD8E6' } // Light blue background color
        } 
      },
      default: { 
        font: { size: 9 }, 
        alignment: { 
          horizontal: 'center' as 'center' 
        } 
      }
    };

    const config: ExcelExportConfig = {
      data: dataToExport,
      columns: columns,
      fileName: this.downloadLink,
      styles: styles
    };

    this.excelExportService.exportToExcel(config);
  }

  confirmYes(){

    this.disableProductsSection = false;
    this.isProductListManualChecked = true;

    // this.notifyRButtonStatus.emit({
    //   from: 'productListManual',
    //   checked: true
    // });

    this.dataShareService.emitDataShareOfProductsSelection({"isDataToRemove":true,"isFrom":"manual"});
  }
  addParentBeforeChild(parent: any) {
    // Get the index of the first child that the parent would belong to
    const firstChildIndex = this.selectedProductRows!.findIndex(item => item.newProductParentID !== null && item.newProductParentID === parent.productID);

    if (firstChildIndex !== -1) {
      // Insert the parent before the first child
      let parentrow:ProductListManualVm={};
      parentrow.categoryID= parent.categoryID;
      parentrow.product = parent.productTitle;
      parentrow.vendorItemNumber = parent.vendorItemNumber;
      parentrow.upc = parent.upc;
      parentrow.isParentSelected = true;
      parentrow.productID = parent.productID;
      parentrow.type = this.componentUsedBy;
      parentrow.newProductID = 0;
      parentrow.refID=0;
      parentrow.parentID=0;
      parentrow.transactionParentId=0;

      // Insert parent row into the productList before the child
      this.selectedProductRows!.splice(firstChildIndex, 0, parentrow);
    }

  }
  // Function to remove the previously selected parent row for the child
  removePreviouslySelectedParent(selectedParent: any) {
    // Find the index of the parent that is selected for the child
    const childParentIndex = this.selectedProductRows!.findIndex(item => 
      item.newProductParentID === selectedParent.productID && item.isParentSelected === true
    );

    if (childParentIndex !== -1) {
      // Remove the previous parent row if found
      this.selectedProductRows!.splice(childParentIndex, 1);
    }
  }

  ///New product logic
  previousParentID: any = null; // Store the previous parent ID
  onSelectNewProductForChild(event: any, row: any,selectedNewProductID?:number): void {

    let alreadyItemSelected = this.selectedProductRows!
        .filter(item => item.newProductParentID == event.value.productID);
        row.newProductParentTitle =  event.value.productTitle;
        // row.vendorItemNumber = '';
        // row.upc = '';
         row.isParent = false;
         row.refId = 0;
         row.productID = 0;
         row.type = this.componentUsedBy;
         row.newProductParentID=event.value.productID;
         row.isParentSelected=false;
   
         this.errorLogService.logMessage(this.selectedProductRows, 'Selected item:');
         if (this.previousParentID !== null && this.previousParentID== event.value.productID) {
          this.removePreviousParentAndChildren(this.previousParentID);
        }
        this.previousParentID = event.value.productID;
        
         const parentExists = this.selectedProductRows!.some(item => item.productID === event.value.productID && item.isParentSelected);
        if (!parentExists) {
          // If the parent doesn't exist, add it before the child
          this.addParentBeforeChild(event.value);
        } else {
           // If the parent exists, find the parent index and add the child after it
        const parentIndex = this.selectedProductRows!.findIndex(item => item.productID === event.value.productID && item.isParentSelected);
        
        // Ensure the parent exists and the index is valid
        if (parentIndex !== -1) {
            // Insert the child after the parent
            const childExistsIndex = this.selectedProductRows!.findIndex(item => item.newProductParentID === event.value.productID && item.productID === row.productID);
            
            if (childExistsIndex !== -1) {
                // Remove the existing child row
                this.selectedProductRows!.splice(childExistsIndex, 1);
            }
            this.selectedProductRows!.splice(parentIndex + 1, 0, row);  // Insert child row after parent
        }
          //retreive child for parent if any
          this.getChildsForSelectedParent(event.value.productID);
        }
    if(selectedNewProductID){
    let selectedNewProductItem = this.selectedProductRows!
        .find(item => item.newProductID == selectedNewProductID);

        if(selectedNewProductItem){
          selectedNewProductItem.newProductParentID=event.value.productID;
          selectedNewProductItem.newProductParentTitle=event.value.productTitle;
        }
      this.errorLogService.logMessage(this.selectedProductRows, 'Selected item:');
      this.assignTransactionParentId();
      this.updatedProductRows.emit(this.selectedProductRows!);
      }
    }
    
    refineCategoryList(selectedCategories: number[]): void {
      if (!this.categoryList) {
          return;
      }
      
      this.refinecategoryList = this.categoryList.filter((category: any) => 
          selectedCategories.includes(category.value)
      );
      if(this.selectedCategories.length==1){
        this.enableAddProduct=false;
        this.newProductCategoryID=this.selectedCategories[0];
        this.onChangeAddProductCategoryID.emit(this.newProductCategoryID ?? undefined);
      }
    }

    changeCategory(){
      this.unsavedChangesService.setUnsavedChanges(true);
      this.enableAddProduct = this.newProductCategoryID === null;
      this.cusromFilterProductItems=[];
      let customProductItemBkp=this.cusromProductItems;
      this.cusromFilterProductItems=customProductItemBkp.filter(x=>x.categoryID==this.newProductCategoryID);
      this.onChangeAddProductCategoryID.emit(this.newProductCategoryID ?? undefined);
    }

    onVendorItemNumberInput(row: any): void {
      if (row.vendorItemNumber) {
          row.vendorItemNumber = row.vendorItemNumber.replace(/[^0-9]/g, '');
          if (this.selectedProductRows) {
            this.selectedProductRows = [...this.selectedProductRows];
        }
      }
  }
  onUPCInput(row: any): void {
    if (row.upc) {
        row.upc = row.upc.replace(/[^0-9]/g, '');
        if (this.selectedProductRows) {
          this.selectedProductRows = [...this.selectedProductRows];
      }
    }
}

checkIsAddEmptyRow(){
  /// to check new product list count 0 then add one empty row

 
  // Check if there are no rows and add a new empty row if necessary
  // if (selectedNewProductRows?.length < 2) {
  //   if(this.selectedProductRows == null
  //     || (this.selectedProductRows != null) && (this.selectedProductRows.length ==0)
  //   )
  //   {
  //     this.selectedProductRows = [];
  //     this.selectedProductRows!.push({
  //       product: null,
  //       vendorItemNumber:'',
  //       upc:'',
  //       refID: 0,
  //       productID: 0,
  //       type: this.componentUsedBy,
  //       isManuallyAddedNewProduct:false,
  //       subProducts:[]});
       
  //   }
  //   else{
  //     let emptyData=new ProductListManualVm();
  //       emptyData.product=null;
  //       emptyData.vendorItemNumber='';
  //       emptyData.upc='';
  //       emptyData.refID=0;
  //       emptyData.productID=0;
  //       emptyData.type=this.componentUsedBy;
  //       emptyData.subProducts=[];
  //       emptyData.isManuallyAddedNewProduct=false;
  //       this.selectedProductRows?.push(emptyData);
  //   }
  // }

  // if (selectedNewProductRows?.length === 0) {
  //   //this.selectedProductRows = [];
  //     this.selectedProductRows!.push({
  //       product: null,
  //       vendorItemNumber:'',
  //       upc:'',
  //       refID: 0,
  //       productID: 0,
  //       type: this.componentUsedBy,
  //       subProducts:[]});
  // }
  // let emptyData=new ProductListManualVm();
  // emptyData.product=null;
  // emptyData.vendorItemNumber='';
  // emptyData.upc='';
  // emptyData.refID=0;
  // emptyData.productID=0;
  // emptyData.type=this.componentUsedBy;
  // emptyData.subProducts=[];
  // emptyData.isManuallyAddedNewProduct=false;
  // emptyData.isItRemove=false;
  // this.selectedProductRows?.push(emptyData);

 
 
    if(this.selectedProductRows && this.selectedProductRows?.length>0){
      this.selectedProductRows.sort((a, b) => {
              if (a.installationProductID && b.installationProductID) {
                return a.installationProductID - b.installationProductID;
              } else if (a.installationProductID) {
                return -1; // If only 'a' has an installationProductID
              } else if (b.installationProductID) {
                return 1; // If only 'b' has an installationProductID
              } else {
                return 0; // If both are undefined
              }
            });
    }
  const selectedNewProductRows = this.selectedProductRows?.filter(
    x => x.isManuallyAddedNewProduct == null || x.isManuallyAddedNewProduct == false
) ?? [];
    this.isShowRemoveProductIcon = selectedNewProductRows?.length > 1;
}

addEmptyProductItem() {
  this.selectedProductRows!.push({
    product: null,
    vendorItemNumber:'',
    upc:'',
    refID: 0,
    productID: 0,
    type: this.componentUsedBy,
    isManuallyAddedNewProduct:false,
    isParentSelected:true,
    isItRemove:false,
    // subProducts:[]
    });     
  const selectedNewProductRows = this.selectedProductRows?.filter(
    x => x.isManuallyAddedNewProduct == null || x.isManuallyAddedNewProduct == false
) ?? [];
    this.isShowRemoveProductIcon = selectedNewProductRows?.length > 1;
}

addDefaultEmptyProductItem() {
  let emptyData=new ProductListManualVm();
  emptyData.product=null;
  emptyData.vendorItemNumber='';
  emptyData.upc='';
  emptyData.refID=0;
  emptyData.productID=0;
  emptyData.type=this.componentUsedBy;
  //emptyData.subProducts=[];
  emptyData.isManuallyAddedNewProduct=false;
  emptyData.isParentSelected=true;
  emptyData.isItRemove=false;
  this.selectedProductRows?.push(emptyData);
  const selectedNewProductRows = this.selectedProductRows?.filter(
    x => x.isManuallyAddedNewProduct == null || x.isManuallyAddedNewProduct == false
) ?? [];
    this.isShowRemoveProductIcon = selectedNewProductRows?.length > 1;
}

getselectedCategoryProducts(selectedCategories: number[]){
  this.categoryProductItems=[];
  // Filter products from orgProductsList based on selected categories
  this.categoryProductItems = this.orgProductsList.filter(product => 
    selectedCategories.includes(product.categoryID)

);
  
}
  

  
}


